// src/pages/Home.jsx
import React from "react";
import HeroSlider from "../components/HeroSlider";
// import StaticServices from "../components/StaticServices";
import VerticalProcessSlider from "../components/VerticalProcessSlider";
import ContactForm from "../components/ContactForm";
import BlogSlider from "../components/BlogSlider";
import ServiceSlider from "../components/ServiceSlider";
import TechnologySlider from "../components/TechnologySlider";
// Import other section components

const Home = () => {
  return (
    <>
      <HeroSlider />
      <ServiceSlider />
      {/* <StaticServices /> */}
      <VerticalProcessSlider />
      <TechnologySlider />
      <ContactForm />
      <BlogSlider />
      {/* Add other sections here */}
    </>
  );
};

export default Home;
